import * as React from 'react';
import { Row, Col, Input, Button, Alert } from 'antd';
import strings from '../../eyeguide-localization/strings.settings';
import '../../css/Login.scss';
import service from '../../service/apolloclient.service';
import Constants from '../common/constants';

interface IForgotPasswordProps {
    match: any;
}

interface IForgotPasswordState {
    email: string;
    classesWithErr: string;
    classesWithoutErr: string;
    errorNew: boolean;
    errorConfirm: boolean;
    isSuccess: boolean;
    errorNotFound: boolean;
    errorWrongPwd: boolean;
    username: string;
    showUsername: boolean;
}

export default class extends React.Component<IForgotPasswordProps, IForgotPasswordState> {

    username: any;

    constructor(props: IForgotPasswordProps) {
        super(props);

        this.state = {
            email: '',
            classesWithErr: 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorNew: false,
            errorConfirm: false,
            isSuccess: false,
            errorNotFound: false,
            errorWrongPwd: false,
            username: '',
            showUsername: false
        };
        document.title = this.props.match.url === '/forgotPassword' ?
            strings.lsForgotPwdTitleTxt : strings.lsForgotUsernameTitleTxt;
    }

    render() {
        const url = this.props.match.url;
        return (
            <div className="Login">
                <div className="container">
                    {!this.state.isSuccess ?
                        <div>
                            <Row>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    <div className="logoContainer">
                                        <h2>{
                                            url === '/forgotPassword' ?
                                                strings.formatString(strings.lsResetPwdTx, this.state.username)
                                                : strings.lsFindUsernameTxt
                                        }
                                        </h2>
                                    </div>
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>
                            <Row className="signInTitle">
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    <h3 className="logoContainer">
                                        {url === '/forgotPassword' ?
                                            strings.lsForgotPwdHeadingTxt
                                            : strings.lsFindUsernameHeadingTxt
                                        }
                                    </h3>
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>
                            <Row className="labelRow">
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    <span> {strings.lsEmailAddressTxt}
                                        :</span>
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>
                            <Row>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    <Input
                                        value={this.state.email}
                                        onChange={(val) => this.setState({ email: val.target.value })}
                                        className={this.state.errorNew ?
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                        placeholder={strings.lsEmailPlaceHolder}
                                        autoFocus={true}
                                    />
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>

                            <div className="passwordContainer" hidden={!this.state.showUsername}>
                                <Row className="labelRow">
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <span> {strings.lsUsernameTxt}
                                            :</span>
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                                <Row>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <Input
                                            ref={e => this.username = e}
                                            value={this.state.username}
                                            onChange={(val) => this.setState({ username: val.target.value })}
                                            className={this.state.errorConfirm ?
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                            placeholder={strings.lsUsernamePlaceholderTxt}
                                        />
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                            </div>

                            {this.state.errorNotFound ?
                                <div className="passwordContainer">
                                    <Row className="row">
                                        <Col xs={1} sm={1} md={2} lg={8} xl={9} />
                                        <Col xs={14} sm={14} md={16} lg={10} xl={6} className="errorFrame">
                                            <span className="error">
                                                {this.state.showUsername ? strings.lsIncorrectUsernameTxt
                                                    : strings.lsIncorrectEmailTxt}
                                            </span>
                                        </Col>
                                        <Col xs={1} sm={1} md={2} lg={6} xl={9} />
                                    </Row>
                                </div> : ''}
                            <div className="signinContainer">
                                <Row>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <Button
                                            className="signin"
                                            type="primary"
                                            onClick={e => {
                                                url === '/forgotPassword' ?
                                                    this.resetPassword() : this.sendUsernames();
                                            }}
                                        >
                                            {url === '/forgotPassword' ?
                                                strings.lsResetPwdBtnTxt : 'Send email'}
                                        </Button>
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                            </div>
                        </div> :
                        <div className="linkExpired">
                            <Alert
                                banner={true}
                                message={strings.lsSuccessTxt}
                                description={url === '/forgotPassword' ?
                                    strings.lsResetEmailSentTxt : 'Email sent!'}
                                type="success"
                                showIcon={true}
                            />
                        </div>}
                </div>
            </div>
        );
    }

    private async sendUsernames() {
        if (this.validateInput()) {
            let ser = new service();
            let resp = await ser.sendUsernames(this.state.email);
            console.log('sendusernames resp', resp);
            if (resp.status === 0) {
                this.setState({
                    isSuccess: true
                });
            } else if (resp.message === Constants.getErrorText().ERROR_NOT_FOUND) {
                this.setState({
                    errorNotFound: true
                });
            }
        } else {
            console.log('false');
        }
    }

    private async resetPassword() {
        if (this.validateInput()) {
            let ser = new service();
            let username: string = this.state.showUsername ? this.state.username : '';
            let resp = await ser.forgotPassword(username, this.state.email);
            console.log('forgotpassword resp', resp);
            if (resp.status === 0) {
                this.setState({
                    isSuccess: true
                });
            } else if (resp.message === Constants.getErrorText().ERROR_USERNAME_REQ) {
                this.setState({
                    showUsername: true
                });
                this.username.focus();
            } else if (resp.message === Constants.getErrorText().ERROR_NOT_FOUND) {
                this.setState({
                    errorNotFound: true
                });
            }
        } else {
            console.log('false');
        }
    }

    private validateInput() {
        this.clearValidations();
        let isValid: boolean = true;
        let errorNew: boolean = false;
        let errorConfirm: boolean = false;
        if (this.state.email !== null &&
            (this.state.email === undefined || this.state.email.trim() === '')) {
            errorNew = true;
        } else {
            errorNew = false;
        }
        if (this.state.showUsername) {
            if (this.state.username !== null &&
                (this.state.username === undefined || this.state.username.trim() === '')) {
                errorConfirm = true;
            } else {
                errorConfirm = false;
            }
        }

        if (errorConfirm || errorNew) {
            isValid = false;
        }
        this.setState({ errorConfirm, errorNew });
        return isValid;
    }

    // private clearForm() {
    //     this.setState({
    //         username: '',
    //         showUsername: false,
    //         errorNotFound: false,
    //         email: ''
    //     })
    // }

    private clearValidations() {
        this.setState({
            errorNotFound: false,
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/login/forgotPassword.tsx